<template>
  <v-dialog v-model="dialog" width="800" persistent>
    <v-card flat>
      <v-card-text>
        <v-row class="justify-center mt-3">
          <v-col xs="12" md="12" lg="12" class="mb-1">
            <v-alert
              :model-value="
                (confirmReturnSwitch || cancelOrderSwitch) &&
                destination == 'inventory' &&
                part.order.id &&
                (part.order.id.status == 1 ||
                  part.order.id.status == 2 ||
                  part.order.id.status == 3)
              "
              type="error"
              variant="tonal"
              border="bottom"
            >
              <v-row class="pa-3">
                {{ $t("return_sold_item") }}
              </v-row>
            </v-alert>
          </v-col>
          <!-----------------------------------------ALERT----------------------------------------->
          <v-col cols="12" xs="12" md="12" lg="12">
            <v-alert
              :model-value="alert.value"
              type="warning"
              variant="tonal"
              border="bottom"
            >
              <v-row align="center" class="py-1">
                <v-col cols="12" xs="12" sm="8">
                  {{ alert.message }}
                </v-col>
                <v-col cols="12" xs="12" sm="4">
                  <!-- Mobile: stacked full-width buttons -->
                  <div class="d-flex d-sm-none flex-column ga-2 mt-2">
                    <v-btn
                      variant="outlined"
                      color="success"
                      block
                      @click="((confirm = true), (alert.value = false))"
                    >
                      {{ $t("parts.ordered_parts.actions.alert.yes") }}
                    </v-btn>
                    <v-btn
                      variant="outlined"
                      color="error"
                      block
                      @click="((confirm = false), (alert.value = false))"
                    >
                      {{ $t("parts.ordered_parts.actions.alert.no") }}
                    </v-btn>
                  </div>
                  <!-- Desktop: unchanged inline buttons -->
                  <v-row class="d-none d-sm-flex mt-2">
                    <v-btn
                      variant="outlined"
                      size="small"
                      color="success"
                      class="mr-1"
                      @click="((confirm = true), (alert.value = false))"
                    >
                      {{ $t("parts.ordered_parts.actions.alert.yes") }}
                    </v-btn>
                    <v-btn
                      variant="outlined"
                      size="small"
                      color="error"
                      @click="((confirm = false), (alert.value = false))"
                    >
                      {{ $t("parts.ordered_parts.actions.alert.no") }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
          <!-------------------------------------CONFIRM ORDER------------------------------------->
          <v-col cols="12" xs="12" sm="6" md="3">
            <v-switch
              v-if="Object.keys(part).length > 0"
              v-model="confirmOrderSwitch"
              :disabled="part.order.id.status !== 0"
              :label="$t('parts.ordered_parts.actions.confirm_order')"
              color="success"
            />
          </v-col>
          <!------------------------------------CONFIRM RETURN------------------------------------->
          <v-col cols="12" xs="12" sm="6" md="3">
            <v-switch
              v-if="Object.keys(part).length > 0"
              v-model="confirmReturnSwitch"
              :disabled="part.order.id.status !== 5"
              :label="$t('parts.ordered_parts.actions.confirm_return')"
              color="orange"
            />
          </v-col>
          <!-------------------------------------REFUSE RETURN------------------------------------->
          <v-col cols="12" xs="12" sm="6" md="3">
            <v-switch
              v-if="Object.keys(part).length > 0"
              v-model="refuseReturnSwitch"
              :disabled="part.order.id.status !== 5"
              :label="$t('parts.ordered_parts.actions.refuse_return')"
              color="red"
            />
          </v-col>
          <!-------------------------------------CANCEL ORDER-------------------------------------->
          <v-col cols="12" xs="12" sm="6" md="3">
            <v-switch
              v-if="Object.keys(part).length > 0"
              v-model="cancelOrderSwitch"
              :label="$t('parts.ordered_parts.actions.cancel_order')"
              color="error"
            />
            <!-- :disabled="
                part.order.id.status !== 0 && part.order.id.status !== 7
              " -->
          </v-col>
        </v-row>
        <!----------------------------------------------------------------------------------------->
        <v-row row align-center justify-center>
          <!-------------------------------------CONFIRM ORDER------------------------------------->
          <v-col v-if="confirmOrderSwitch" cols="12" xs="12">
            <confirm-order
              ref="confirmOrder"
              :data="{ weight: part.weight, dimensions: part.dimensions }"
              :order_id="orderId"
              :part_id="partId"
              @confirmed="actionCompleted"
              @error="close"
            />
          </v-col>
          <!-------------------------------------RETURN NOTES-------------------------------------->
          <v-col
            v-if="Object.keys(part).length > 0 && part.order.id.status === 5"
            xs="12"
          >
            <v-row align-center justify-center>
              <v-col  cols="12" xs="12" sm="10">
                <v-textarea
                  v-model="part.order.id.comment"
                  :disabled="!refuseReturnSwitch"
                  :label="$t('parts.ordered_parts.actions.return_notes')"
                  color="red"
                />
              </v-col>
            </v-row>
          </v-col>
          <!-------------------------------------CANCEL ORDER-------------------------------------->
          <v-col v-if="Object.keys(part).length > 0 && cancelOrderSwitch">
            <v-row align-center justify-center wrap>
              <v-col  cols="12" xs="12" sm="8">
                <v-select
                  v-model="destination"
                  :items="destinationItems"
                  :label="
                    $t('parts.ordered_parts.actions.select_parts_destination')
                  "
                  color="red"
                  item-title="title"
                  item-value="value"
                />
              </v-col>
              <v-col xs="12" cols="12">
                <v-textarea
                  v-model="cancelComment"
                  :label="$t('parts.ordered_parts.actions.comment')"
                  color="red"
                />
              </v-col>
            </v-row>
          </v-col>
          <!--------------------------------------------------------------------------------------->
        </v-row>
      </v-card-text>
      <!------------------------------------------ACTIONS------------------------------------------>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" variant="outlined" @click="close">
          {{ $t("close") }}
        </v-btn>
        <v-btn
          v-if="confirmOrderSwitch"
          :disabled="!confirm"
          :loading="loading"
          color="success"
          variant="outlined"
          @click="confirmOrder"
        >
          {{ $t("parts.ordered_parts.actions.confirm") }}
        </v-btn>
        <v-btn
          v-if="confirmReturnSwitch"
          :disabled="!confirm"
          :loading="loading"
          color="orange"
          variant="outlined"
          @click="confirmReturn"
        >
          {{ $t("parts.ordered_parts.actions.confirm") }}
        </v-btn>
        <v-btn
          v-if="refuseReturnSwitch"
          :disabled="!confirm"
          :loading="loading"
          color="red"
          variant="outlined"
          @click="refuseReturn"
        >
          {{ $t("parts.ordered_parts.actions.refuse") }}
        </v-btn>
        <v-btn
          v-if="cancelOrderSwitch"
          :disabled="!confirm"
          :loading="loading"
          color="error"
          variant="outlined"
          @click="cancelOrder"
        >
          {{ $t("parts.ordered_parts.actions.cancel_order") }}
        </v-btn>
      </v-card-actions>
      <!------------------------------------------------------------------------------------------->
    </v-card>
  </v-dialog>
</template>

<script>
import putRequest from "../../api/putRequest";
import ConfirmOrder from "./confirmOrder.vue";

export default {
  components: {
    "confirm-order": ConfirmOrder,
  },
  data: () => ({
    dialog: false,
    loading: false,
    alert: {
      value: false,
      message: "",
    },
    confirm: false,
    confirmOrderSwitch: false,
    confirmReturnSwitch: false,
    refuseReturnSwitch: false,
    cancelOrderSwitch: false,
    destination: "inventory",
    destinationItems: [
      { title: "Inventory", value: "inventory" },
      { title: "Damaged Parts", value: "damaged" },
      { title: "Lost Parts", value: "lost" },
    ],
    part: {},
    orderId: null,
    partId: null,
    cancelComment: "",
  }),
  watch: {
    confirmOrderSwitch(value) {
      if (value) {
        this.cancelOrderSwitch = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.ordered_parts.actions.alert.confirm_order_message",
        );
      } else if (!this.cancelOrderSwitch) {
        this.confirm = false;
        this.alert.value = false;
      }
    },
    cancelOrderSwitch(value) {
      if (value) {
        this.confirmOrderSwitch = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.ordered_parts.actions.alert.cancel_order_message",
        );
      } else if (!this.confirmOrderSwitch) {
        this.confirm = false;
        this.alert.value = false;
      }
    },
    confirmReturnSwitch(value) {
      if (value) {
        this.refuseReturnSwitch = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.ordered_parts.actions.alert.confirm_return_message",
        );
      } else {
        this.confirm = false;
        if (!this.refuseReturnSwitch) {
          this.alert.value = false;
        }
      }
    },
    refuseReturnSwitch(value) {
      if (value) {
        this.confirmReturnSwitch = false;
        this.confirm = false;
        this.alert.value = true;
        this.alert.message = this.$t(
          "parts.ordered_parts.actions.alert.refuse_return_message",
        );
      } else {
        this.confirm = false;
        if (!this.confirmReturnSwitch) {
          this.alert.value = false;
        }
      }
    },
  },
  mounted() {
    this.getLocale();
  },
  methods: {
    getLocale() {
      this.destinationItems[0].title = this.$t(
        "parts.ordered_parts.actions.destination.inventory",
      );
      this.destinationItems[1].title = this.$t(
        "parts.ordered_parts.actions.destination.damaged_parts",
      );
      this.destinationItems[2].title = this.$t(
        "parts.ordered_parts.actions.destination.lost_parts",
      );
    },
    open(data) {
      this.part = data;
      this.orderId = data.order.id._id;
      this.partId = data._id;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.confirmOrderSwitch = false;
      this.confirmReturnSwitch = false;
      this.cancelOrderSwitch = false;
      this.destination = "inventory";
      this.part = {};
    },
    confirmOrder() {
      const { confirmOrder } = this.$refs;
      confirmOrder.validate((callback) => {
        if (callback) {
          this.loading = true;
        }
      });
    },
    confirmReturn() {
      this.loading = true;
      putRequest("/part/ordered/return", `order_id=${this.orderId}`)
        .then(() => {
          this.actionCompleted();
        })
        .catch(() => {
          this.close();
        });
    },
    refuseReturn() {
      this.loading = true;
      putRequest("/part/ordered/refuse", `order_id=${this.orderId}`, {
        comment: this.part.order.id.comment,
      })
        .then(() => {
          this.actionCompleted();
        })
        .catch(() => {
          this.close();
        });
    },
    cancelOrder() {
      this.loading = true;
      putRequest(
        "/part/ordered/cancel",
        `order_id=${this.orderId}&part_id=${this.partId}&user_id=${
          this.$store.getters.userId
        }&destination=${this.destination}`,
        { comment: this.cancelComment },
      )
        .then(() => {
          this.actionCompleted();
        })
        .catch(() => {
          this.close();
        });
    },
    actionCompleted() {
      this.loading = false;
      this.$emit("action-completed");
      this.close();
    },
  },
};
</script>
